import { render, staticRenderFns } from "./WidgetSocialMediaItem.vue?vue&type=template&id=37ee19f8&scoped=true&lang=pug"
import script from "./WidgetSocialMediaItem.vue?vue&type=script&lang=ts"
export * from "./WidgetSocialMediaItem.vue?vue&type=script&lang=ts"
import style0 from "./WidgetSocialMediaItem.vue?vue&type=style&index=0&id=37ee19f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee19f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VList,VListItem,VListItemIcon,VMenu,VRow})
